import dayjs from "dayjs";

export const mapApiToForm = (data) => {
    return {
        formValues: {
            cardCode: data.cardCode,
            mode: data.mode,
            balanceTypeId: data.balanceTypeId,

            docNumber: data.docNumber,
            docDate: dayjs(data.docDate, "DD.MM.YYYY"),
            period: dayjs(`${data.docYear}-${data.docMonth}`, "YYYY-MM"),

            expense: '14111100',
            //contractId: data.contractId,

            currency: data.currency,
            bxmCode: data.bxmCode,
            clientId: data.clientId,
            codeFilial: data.codeFilial,
            filename: data.filename,
            account: data.account,
            accountBalance: data.accountBalance,
            purpose: data.payPurpose || "",
        },

        cards: data.balance.map((item, index) => ({
            mbat_id: index + 1,
            card_number: item.cardNumber,
            amount: item.balanceAmount,
            orderNum: index + 1,
            date_expire: '0000',
            client_uid: item.employeeClientId,
            contract_id: item.employeeContractId,
            embossed_name: item.embossedName,
        })),
    };
};